/** @format */
import { css } from 'styled-components';

/**
 * Base styles for the tooltip component
 *
 * */
const baseStyles = css`
    margin: var(--layout-spacing-24);
`;

/**
 * The tooltip component styles
 *
 * */
export const styles = () => css`
    ${baseStyles}
`;
